import { AudienceMessageSection } from './audience-message-section';
import { CampaignSettingsCard } from './campaign-settings-card';

export function PoolSetup() {
  return (
    <div className="flex flex-col gap-3">
      <CampaignSettingsCard />
      <AudienceMessageSection />
    </div>
  );
}
